export class AddOrUpdateSetting {
    public settingKey : string;
    public settingValue : string;
}

